const BRAND = process.env.REACT_APP_BRAND || "nettv";

const configs = {
  nettv: {
    name: "NetTV",
    tagline: "Premium IPTV Experience",
    subTagline: "Stream thousands of live TV channels, movies, and series on any device. Simple setup, premium quality.",
    badgeText: "7-Day Free Trial Available",
    accent: "#22d3ee",
    buttonStyle: { background: "#06b6d4", color: "#000000", borderRadius: "0.5rem" },
    statColor: "#22d3ee",
    logoNav: "nettv-logo.png",
    logoHero: "nettv-logo.png",
    logoAlt: "NetTV",
    heroLogoClass: "h-24 md:h-32",
    showNameBesideLogo: false,
    bg: "#050507",
    bgGradient: null,
    isPulse: false,
    isArc: false,
    fontFamily: "'Manrope', sans-serif",
    showSplash: false,
  },
  arcplayer: {
    name: "ArcPlayer",
    tagline: "Stream. Sharp. Clear.",
    subTagline: "Crystal-clear streaming engineered for precision. Every frame, every channel, delivered sharp.",
    badgeText: "Zero Buffering Technology",
    accent: "#00BFFF",
    buttonStyle: { background: "#00BFFF", color: "#000000", borderRadius: "4px", fontWeight: "600" },
    statColor: "#00BFFF",
    logoNav: "arc-icon.jpg",
    logoHero: "arc-wordmark.jpg",
    logoAlt: "ArcPlayer",
    heroLogoClass: "h-14 md:h-20",
    showNameBesideLogo: true,
    bg: "#060810",
    bgGradient: "radial-gradient(ellipse 80% 50% at 50% -10%, rgba(0,191,255,0.18) 0%, transparent 60%)",
    isPulse: false,
    isArc: true,
    fontFamily: "'Space Grotesk', sans-serif",
    showSplash: true,
  },
  pulseplayer: {
    name: "PulsePlayer",
    tagline: "Feel Every Frame.",
    subTagline: "Immersive streaming powered by pure energy. Vibrant. Alive. Electric.",
    badgeText: "Live Energy Streaming",
    accent: "#00E5FF",
    accentSecondary: "#A855F7",
    buttonStyle: {
      background: "linear-gradient(135deg, #00E5FF 0%, #A855F7 100%)",
      color: "#000000",
      borderRadius: "9999px",
      fontWeight: "600",
    },
    statColor: "#00E5FF",
    logoNav: "pulse-icon.jpg",
    logoHero: "pulse-wordmark.jpg",
    logoAlt: "PulsePlayer",
    heroLogoClass: "h-14 md:h-20",
    showNameBesideLogo: true,
    bg: "#080810",
    bgGradient:
      "radial-gradient(ellipse 70% 50% at 8% 50%, rgba(168,85,247,0.15) 0%, transparent 50%), radial-gradient(ellipse 70% 50% at 92% 50%, rgba(0,229,255,0.15) 0%, transparent 50%)",
    isPulse: true,
    isArc: false,
    fontFamily: "'Outfit', sans-serif",
    showSplash: true,
  },
};

export const brand = configs[BRAND] || configs.nettv;
export const brandId = BRAND;
